import api from 'api';

export const getCountries = (params) => {
  return api.get('/countries', params, 'bearer');
};

export const getUserCountries = (params) => {
  return api.get('/user_countries', params, 'bearer');
};

export const createUserCountry = (body) => {
  return api.post('/user_countries', body, 'bearer');
};

export const deleteUserCountry = (id) => {
  return api.delete(`/user_countries/${encodeURIComponent(id)}`, 'bearer');
};

export const getContactCountries = (params) => {
  return api.get('/contact_countries', params, 'bearer');
};

export const createContactCountry = (body) => {
  return api.post('/contact_countries', body, 'bearer');
};

export const deleteContactCountry = (id) => {
  return api.delete(`/contact_countries/${encodeURIComponent(id)}`, 'bearer');
};
